import { useCallback } from 'react';
import { ProjectFormModel } from '@app/modules/projects/inputs/project-admin/project-form/project-form-types';
import { UseFormReturn } from 'react-hook-form';
import styles from './tabTitle.module.scss';

export type Props = {
  title: string;
  value: string;
  index: number;
  setSelectedTab: (index: number) => void;
  isActive?: boolean;
  formMethods: UseFormReturn<ProjectFormModel, any, undefined>;
  setName: any;
};

const TabTitle = (props: Props): JSX.Element => {
  const { title, value, setSelectedTab, index, isActive, formMethods, setName } = props;

  const handleOnClick = useCallback(
    (e: any) => {
      e.preventDefault();
      setSelectedTab(index);
      formMethods.setValue(setName, value);
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    },
    [setSelectedTab, index, formMethods, setName, value]
  );

  const handleKeyPress = useCallback(
    (e: any) => {
      if (e.key === 'Enter' || e.keyCode === 13) {
        handleOnClick(e);
      }
    },
    [handleOnClick]
  );

  return (
    <li
      className={`${styles.title} ${isActive ? 'active' : ''}`}
      data-testid={value}
      onClick={handleOnClick}
      onKeyPress={handleKeyPress}
      tabIndex={0}>
      {title}
    </li>
  );
};

export default TabTitle;
